module.exports = __webpack_public_path__ + "static/media/hero_banner_1199.5c2e0799.jpg";